export default "__VITE_ASSET__63bf6e3a__"